import { CustomMessageField } from '@features/components/Chat/constants';
import {
  ClinicalDataShareMessage,
  OrganApprovalShareMessage,
  QuoteDataShareMessage,
} from '@features/components/Chat/components/ChatContent/Messages/types/chatMessages';
import { Channel } from 'stream-chat';
import { MessagePayload } from '@features/components/Chat/components/hooks/useSendSharedMessage';
import { CaseStatus, ClinicalItemType, DonorType, OrganType } from '@/api/apis/case';
import { StreamChannelType } from '@/api/apis/chat';

export enum StreamUserRole {
  CustomerAdmin = 'customer_admin',
  Moderator = 'moderator',
  Customer = 'customer',
  CustomerAdminAuditor = 'customer-admin-auditor',
  User = 'user',
  QuoteApprover = 'quote-approver',
  SeniorLogisticManager = 'senior-logistic-manager',
  Administrator = 'administrator',
  NationalCsManagement = 'national-cs-management',
  ClinicalCoordinatorManagement = 'clinical-coordinator-management',
  ClinicalAuditor = 'clinical-auditor',
  SuperAdmin = 'super-admin',
  Section16Officer = 'section-16-officer',
  LogisticsTeamManagement = 'logistics-team-management',
  OMS = 'organ-management-specialist',
  TechSupportAdmin = 'tech-support-admin',
  OrganLeadership = 'organ-leadership',
}

export enum ChatFilterArrayKeys {
  OrganTypes = 'organTypes',
  DonorTypes = 'donorTypes',
  ChatTypes = 'chatTypes',
}
export type ChatFilterState = {
  organTypes: OrganType[];
  donorTypes: DonorType[];
  chatTypes: StreamChannelType[];
  unreadOnly: boolean;
};

export type RenderChannelsOptions = {
  caseId?: string;
  uiFilters?: ChatFilterState;
  inlineLayout?: boolean;
  chatTypes?: StreamChannelType[];
};

export type UseChatFiltersReturn = {
  draftFilters: ChatFilterState;
  filters: ChatFilterState;
  version: number;
  setOrganTypes: (v: OrganType[]) => void;
  setDonorTypes: (v: DonorType[]) => void;
  setChatTypes: (v: StreamChannelType[]) => void;
  toggleUnreadOnly: () => void;
  applyFilters: () => void;
  clearAll: () => void;
  setAndApplyFilter: <K extends keyof ChatFilterState>(key: K, value: ChatFilterState[K]) => void;
};

export type ChatProps = {
  caseId?: string;
  txCenterId?: string;
  caseStatus?: CaseStatus;
  organType?: OrganType;
  donorType?: DonorType;
  inlineLayout?: boolean;
  filterState?: UseChatFiltersReturn;
};

export type ShareToChatChatValues = Pick<ChatProps, 'caseStatus' | 'organType' | 'donorType'>;

export type ShareToChatModalProps = {
  open: boolean;
  channels: Channel[];
  onClose: () => void;
  sharedContent: PendingShare | null;
  modalProps: ShareToChatChatValues;
  sendMessage: (channel: Channel, messagePayload: MessagePayload) => Promise<void>;
};

export type PendingShare = {
  [CustomMessageField.ClinicalDataAttachment]?: ClinicalDataShareMessage;
  [CustomMessageField.QuoteAttachment]?: QuoteDataShareMessage;
  [CustomMessageField.OrganApprovalAttachment]?: OrganApprovalShareMessage;
  clinicalItemType?: ClinicalItemType;
};

export type TxCenter = {
  id: string;
  name: string;
  code: string;
};
